import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarComponent } from '../../../components/snackbar/snackbar.component';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {

  constructor(private snackBar: MatSnackBar
    ) {  }

  openSnackBar(message: string, panelClass: string[], duration?:number ) {
    this.snackBar.openFromComponent(SnackbarComponent, {
      data: message,
      panelClass: panelClass,
      duration : duration
    });
  }

  /**
   * Affiche un message d'erreur
   * @param message Texte du message d'erreur
   * @param duration Durée d'affichage en millisecond
   */
  displayError(message:string, duration?:number){
    this.openSnackBar(
      message, ["custom-style-error"],duration
    );
  }

  /**
   * Affiche un message d'information
   * @param message Texte du message
   * @param duration Durée d'affichage en millisecond
   */
  displayInformation(message:string, duration?:number){
    this.openSnackBar(
      message, ["toast-information"],duration
    );
  }

    /**
   * Affiche un message de succès
   * @param message Texte du message 
   * @param duration Durée d'affichage en millisecond
   */
  displaySuccess(message:string, duration?:number){
    this.openSnackBar(
      message, ["toast-success"],duration
    );
  }
}
